var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08425 11.0845L8.55114 6.68381H10.4485L11.9154 11.0845L16.316 12.5514V14.4487L11.9154 15.9156L10.4485 20.3163H8.55114L7.08425 15.9156L2.68359 14.4487V12.5514L7.08425 11.0845ZM9.49982 10.1623L8.8235 12.1913L8.19105 12.8237L6.1621 13.5L8.19105 14.1764L8.8235 14.8088L9.49982 16.8378L10.1761 14.8088L10.8086 14.1764L12.8375 13.5L10.8086 12.8237L10.1761 12.1913L9.49982 10.1623Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1505 5.1507L16.9306 2.8103H18.069L18.8492 5.1507L21.1896 5.93083V7.06925L18.8492 7.84938L18.069 10.1898H16.9306L16.1505 7.84938L13.8101 7.06925V5.93083L16.1505 5.1507Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaksIcon);
export default __webpack_public_path__ + "static/media/taksIcon.50dd83019c6128ffc4a30c19936da644.svg";
export { ForwardRef as ReactComponent };